import React from 'react';

interface PlantOverviewSummaryCardProps {
  title: string;
  firstItem: string;
  firstItemValue: string;
  firstItemUnit: string;
  secondItem: string;
  secondItemValue: string;
  secondItemUnit: string;
  className?: string;
}

const PlantOverviewSummaryCard: React.FC<PlantOverviewSummaryCardProps> = ({
  title,
  firstItem,
  firstItemValue,
  firstItemUnit,
  secondItem,
  secondItemValue,
  secondItemUnit,
  className,
}) => {
  return (
    <div
      className={`${className} w-[345px] rounded-[10px] bg-white px-[30px] py-[30px] leading-none shadow-3`}
    >
      <p className="noto-15-medium text-dark-3">{title}</p>
      <div className="mt-[30px] flex items-center justify-between">
        <span className="noto-14-light text-dark-6">{firstItem}</span>
        <div>
          <span
            className={`pop-bold-6 tracking-[-0.24px] ${firstItemValue.trim() === '0' ? 'text-dark-10' : 'text-dark-3'}`}
          >
            {firstItemValue}
          </span>
          <span
            className={`pop-bold-5 tracking-[-0.2px] ${firstItemValue.trim() === '0' ? 'text-dark-10' : 'text-dark-3'}`}
          >
            {firstItemUnit}
          </span>
        </div>
      </div>
      {/* divider */}
      <div className="mt-[20px] h-[1px] w-[285px] bg-[#E8EEEE]"></div>
      <div className="mt-[20px] flex items-center justify-between">
        <span className="noto-14-light text-dark-6">{secondItem}</span>
        <div>
          <span
            className={`pop-bold-6 tracking-[-0.24px] ${secondItemValue.trim() === '0' ? 'text-dark-10' : 'text-dark-3'}`}
          >
            {secondItemValue}
          </span>
          <span
            className={`pop-bold-5 tracking-[-0.2px] ${secondItemValue.trim() === '0' ? 'text-dark-10' : 'text-dark-3'}`}
          >
            {secondItemUnit}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PlantOverviewSummaryCard;
